// ProductQRList.js

import React, {Component} from 'react';
import {Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover} from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import {JsonToExcel} from 'react-json-excel';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';



const className = 'class-name-for-style',
    filename = 'GoodsProduct_Excel-file',
    fields = {
        "ID": "#",
        "QRCODE": "QRCODE",
        "SERIAL": "SERIAL",
        "USEDATE": "USEDATE",
        "DOWNDATE": "DOWNDATE"
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "34px",
        verticalAlign: 'middle'
    }

export default class GoodsProductQRList extends Component {
    static defaultProps = {
        item: null,
        images: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.emptyItem = {
            ID: 0,
            PCODE: "0000",
            QRCODE: "",
            SERIAL: "",
            USEDATE: "",
            DOWNDATE: ""
        }
        this.state = {
            FILE: '',
            rowlist: [],
            answervisible: false,
            enable: true,
            item: this.props.item,
            details: [],
            newQR: false
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({item: nextProps.item, images: nextProps.images});
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleClose() {
        this.setState({answervisible: false});
    }

    handleGetInfo(event) {
        Config.fetchData('goodsProductQR', {
            PCODE: this.state.item.PCODE
        }, (result, count) => {
            result.forEach(element => {
                element.USEDATE = element.USEDATE == null ? '' : element.USEDATE;
                element.DOWNDATE = element.DOWNDATE == null ? '' : element.DOWNDATE;
                element.MEMO = element.MEMO == null ? '' : element.MEMO;
            });
            this.setState({details: result}, () => {
                this.handleChangeDetail();
            })
        }, true);
    }

    handleChangeDetail() {
        this.setState({rowlist: this.state.details});
    }


    handleSubmit(event) {
        if (!this.state.newQR)
            return;

        var result = confirm("저장 하시겠습니까?");
        if (result) {

            this.setState({newQR: false});


            var arrData = [];
            var list = this.state.rowlist;
            for (var i = 0; i < list.length; ++i) {
                arrData.push([list[i].PCODE, list[i].QRCODE, list[i].SERIAL])
            }

            console.log('DATA', arrData)
            Config.fetchData('insGoodsProductQR', {
                PCODE: this.state.item.PCODE,
                DATA: arrData
            }, (result, count) => {
                console.log('insGoodsProductQR=', count);
                if (count < 1) {
                    alert("QR 코드가 등록되지 않았습니다.\nQR목록을 확인해 주세요.");
                } else {
                    alert(count + "개의 QR 코드가 등록 되었습니다.")
                }
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleRemove(event) {
        var result = confirm("삭제 하시겠습니까?");
        // if (result) {
        //     Config.fetchData('delproductQR', {
        //         PCODE: this.state.item.PCODE
        //     }, (result, count) => {
        //         console.log('delproductQR=', count);
        //         this.refreshGetInfo();
        //     }, true);
        // }
        event.preventDefault();
    }

    handleGetFromS3(event) {
        Config.fetchData('getGoodsProductFiletext', {
            PCODE: this.state.item.PCODE,
            PATH: this.state.FILE
        }, (result, count) => {
            console.log('getGoodsProductFiletext=', result);
            var imagelist = [];
            for (var i = 1; i < result.length; ++i) {
                var qrinfo = result[i].split(',');
                if (qrinfo.length > 2) {
                    console.log('qrinfo', qrinfo)
                    var item = {...this.emptyItem};
                    item.ID = i;
                    item.PCODE = this.state.item.PCODE;
                    item.QRCODE = qrinfo[0].trim();
                    item.SERIAL = qrinfo[2].trim();
                    imagelist.push(item);
                }
            }

            if (imagelist.length > 0)
                this.setState({newQR: true});

            this.setState({rowlist: imagelist})
        }, true);
        event.preventDefault();
    }


    handleRowClick = () => {
        event.preventDefault();
    }

    handleChangeFILE(event) {
        this.setState({FILE: event.target.value});
    }

    handleRowChange = (item) => {
        var row = this.state.rowlist;
        // row[item.ID] = item;
        // console.log( JSON.stringify( row ) );
        this.setState({rowlist: row});
        event.preventDefault();
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const {rowCount} = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({scrollToIndex});
    }

    _rowClassName({index}) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = {borderRadius: 5};
        return (
            <div className="box" >
                <div className="row" style={{margin: 10}}>
                    <div className="col-md-12">
                        <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                        <Button variant="primary" onClick={this.handleGetFromS3.bind(this)}>S3에서 가져오기</Button>
                        {this.state.rowlist.length > 0 ?
                            <JsonToExcel
                                data={this.state.rowlist}
                                className={className}
                                filename={filename}
                                fields={fields}
                                style={style}
                            />
                            :
                            null
                        }
                        {/* <Button variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button> */}
                    </div>
                </div>
                <div className="row" style={{margin: 10}}>
                    <AutoSizer disableHeight>
                        {({width}) => (
                            <Table
                                ref="Table"
                                headerClassName={'headerColumn'}
                                onRowClick={this.handleRowClick}
                                headerHeight={30}
                                height={500}
                                noRowsRenderer={this._noRowsRenderer}
                                overscanRowCount={10}
                                rowClassName={this._rowClassName}
                                rowHeight={40}
                                rowGetter={({index}) => this.state.rowlist[index]}
                                rowCount={this.state.rowlist.length}
                                scrollToIndex={this.state.scrollToIndex}
                                width={width}>
                                <Column
                                    width={100}
                                    disableSort
                                    label="#"
                                    dataKey="ID"
                                    className={'exampleColumn'}
                                    cellRenderer={({cellData}) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={300}
                                    disableSort
                                    label="QR CODE"
                                    dataKey="QRCODE"
                                    className={'exampleColumn'}
                                    cellRenderer={({cellData}) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={300}
                                    disableSort
                                    label="시리얼번호"
                                    dataKey="SERIAL"
                                    className={'exampleColumn'}
                                    cellRenderer={({cellData}) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={300}
                                    disableSort
                                    label="사용 날짜"
                                    dataKey="USEDATE"
                                    className={'exampleColumn'}
                                    cellRenderer={({cellData}) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={300}
                                    disableSort
                                    label="다운로드 날짜"
                                    dataKey="DOWNDATE"
                                    className={'exampleColumn'}
                                    cellRenderer={({cellData}) => cellData}
                                    flexGrow={1}
                                />
                            </Table>
                        )}
                    </AutoSizer>
                    {/* <ScrollArea style={{  width: '100%' , height: 500 }}
                        className="area"
                        contentClassName="content"
                        verticalScrollbarStyle={scrollbarStyles}
                        verticalContainerStyle={scrollbarStyles}
                        horizontalScrollbarStyle={scrollbarStyles}
                        horizontalContainerStyle={scrollbarStyles}
                        smoothScrolling= {true}
                        minScrollSize={5}
                        onScroll={this.handleScroll}
                        >
                    <Table striped bordered hover>
                    <thead>
                        <tr>
                        <td>#</td>
                        <td>QR CODE</td>
                        <td>EMAIL</td>
                        <td>사용여부</td>
                        <td>OLD QR</td>
                        </tr>
                    </thead>
                    <tbody>

                    { this.state.rowlist.map((item, index) =>
                        <RowItem key={index} item={item} onPress={this.handleRowClick.bind(this)} onChange={this.handleRowChange.bind(this)}/>
                    )}

                    </tbody>
                    </Table>
                    </ScrollArea> */}
                </div>


            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/DigitalGoods/GoodsProductQRList.js